import styled from "@emotion/styled";

export const ButtonContainer = styled.div`
  margin-top: 16px;
  text-align: right;
`;
